'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$() {
  this.aHe = null;
  this.aHf = false;
  this.aH8 = null;
  this.aH9 = false;
  this.aHa = null;
  this.aHb = false;
  this.aHc = null;
  this.aHd = false;
  this.aHg = null;
  this.aHh = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeBigDecimal__$init$__V(this);
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$.prototype = $p;
$p.o3 = (function() {
  if ((!this.aHf)) {
    this.aHe = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBigDecimal$$anon$3(this);
    this.aHf = true;
  }
  return this.aHe;
});
$p.iq = (function() {
  if ((!this.aH9)) {
    this.aH8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aH9 = true;
  }
  return this.aH8;
});
$p.J2 = (function(x$0) {
});
$p.ase = (function() {
  if ((!this.aHb)) {
    this.aHa = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var $x_1 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$();
      var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_package$().ox();
      var e$proxy12 = $x_1.iu(this$1.pp(0, this$1.hX));
      if ((e$proxy12 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy12.bj) + ")"));
      }
      if ((e$proxy12 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        return e$proxy12.aI;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy12);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aHb = true;
  }
  return this.aHa;
});
$p.brS = (function() {
  if ((!this.aHd)) {
    this.aHc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Additional Credit";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aHd = true;
  }
  return this.aHc;
});
$p.bNR = (function() {
  if ((!this.aHh)) {
    this.aHg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().Cc;
    this.aHh = true;
  }
  return this.aHg;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$, "app.data.data_point_types$package$AdditionalCredit$", ({
  Fv: 1,
  B: 1,
  C: 1,
  cz: 1,
  fX: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$AdditionalCredit$ };
//# sourceMappingURL=app.data.data_point_types$package$-Additional-Credit$.js.map
